import axiosInstance from './axiosInstance';
import {
  ItemSupplier,
  CreateItemSupplier,
  UpdateItemSupplier,
  ItemBySupplier,
  ItemPolicy,
  UpdateItemPolicy,
} from '../types/itemSuppliers.types';

// Re-export types for convenience
export type { ItemSupplier, CreateItemSupplier as CreateItemSupplierDto, UpdateItemSupplier as UpdateItemSupplierDto, ItemBySupplier, ItemPolicy as ItemPolicyUpdateDto };

export const itemSuppliersService = {
  getAll: async (params?: {
    itemId?: number;
    supplierId?: number;
    isActive?: boolean;
  }): Promise<ItemSupplier[]> => {
    const response = await axiosInstance.get<ItemSupplier[]>('/ItemSuppliers', { params });
    return response.data;
  },

  getItemsBySupplier: async (
    supplierId: number,
    activeOnly: boolean = true
  ): Promise<ItemBySupplier[]> => {
    const response = await axiosInstance.get<ItemBySupplier[]>(
      `/ItemSuppliers/by-supplier/${supplierId}`,
      { params: { activeOnly } }
    );
    return response.data;
  },

  getSuppliersByItem: async (
    itemId: number,
    activeOnly: boolean = true
  ): Promise<ItemSupplier[]> => {
    const response = await axiosInstance.get<ItemSupplier[]>(
      `/ItemSuppliers/by-item/${itemId}`,
      { params: { activeOnly } }
    );
    return response.data;
  },

  getItemPolicy: async (itemId: number): Promise<ItemPolicy> => {
    const response = await axiosInstance.get<ItemPolicy>(`/ItemSuppliers/policy/${itemId}`);
    return response.data;
  },

  getPrice: async (
    itemId: number,
    supplierId: number,
    unitId: number
  ): Promise<{ itemId: number; supplierId: number; unitId: number; price: number } | null> => {
    try {
      const response = await axiosInstance.get<{ itemId: number; supplierId: number; unitId: number; price: number }>(
        '/ItemSuppliers/price',
        { params: { itemId, supplierId, unitId } }
      );
      return response.data;
    } catch (error) {
      return null;
    }
  },

  create: async (data: CreateItemSupplier): Promise<ItemSupplier> => {
    const response = await axiosInstance.post<ItemSupplier>('/ItemSuppliers', data);
    return response.data;
  },

  update: async (
    id: number,
    data: UpdateItemSupplier
  ): Promise<ItemSupplier> => {
    const response = await axiosInstance.put<ItemSupplier>(`/ItemSuppliers/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/ItemSuppliers/${id}`);
  },

  updateItemPolicy: async (data: UpdateItemPolicy): Promise<void> => {
    await axiosInstance.put(`/Items/${data.itemId}/policy`, {
      isSupplierRequired: data.isSupplierRequired,
      isPriceControlled: data.isPriceControlled,
    });
  },
};